import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import 'core-js/es6/array' // IE11 requirement https://github.com/angular/angular-cli/issues/4128

import rootReducer from './reducers'
import rootSaga from './sagas'
import Root from './components/Root'
// import registerServiceWorker from './registerServiceWorker'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware()
const store = createStore(
  rootReducer,
  composeEnhancers(
  applyMiddleware(sagaMiddleware)
  )
)
sagaMiddleware.run(rootSaga)

// store.subscribe(() => console.log('store', store.getState()))

ReactDOM.render(<Root store={store}/>, document.getElementById('root'))
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js